module.exports = __webpack_public_path__ + "img/YouPlusEN-10.39b11813.jpg";